<template>
  <a-tabs v-show="tabs.length > 0" ref="tabs" :tabBarGutter="20" :activeKey="activePath" class="main-header-tabs" style="height: 40px; line-height: 40px;">
    <a-tab-pane v-for="tab in tabs" :key="tab.path">
      <div class="tabs-item" slot="tab">
        <router-link :to="{path: tab.path, query: { ...tab.query, tab: 1 }}" style="color:#fff;" draggable="true">
          <span v-show="tab.title" class="main-admin-tabs-item">
            <span>{{ tab.title }}</span>
            <div v-show="tab.title !== '首页'" class="tabs-close-x" @click.prevent="onClose(tab)">
              <sass-icon type="hi-guanbidanchuangdanchuang" class="tabs-close" />
            </div>
          </span>
        </router-link>
      </div>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import { mapGetters } from 'vuex'
import CommonIcon from '@/components/common-icon'
import Sortable from 'sortablejs'

export default {
  components: {
    CommonIcon
  },
  mounted () {
    this.initDrag()
    this.activePath = this.path
  },
  computed: {
    ...mapGetters(['microApps', 'tabs']),
    path () {
      return this.$route.path
    },
    activePath: {
      get () {
        const active = this.$store.state.tabs.activePath
        return active || ''
      },
      set (val) {
        this.$store.commit('SET_ACTIVE_PATH', val)
      }
    }
  },
  watch: {
    path (val) {
      this.activePath = val
    }
  },
  methods: {
    // 点击切换
    onChange(path) {
      if (!path) return
      const route = this.tabs.filter((item) => item.path === path)[0]
      this.$router.push({ path: path, query: { ...route.query, tab: 1 } })
    },
    // 点击关闭
    onClose(tab) {
      if (!tab) return
      this.$store.dispatch('setCloseType')
      this.$store.dispatch('removeTab', tab)
    },
    initDrag () {
      const that = this
      this.$nextTick(() => {
        const xTabs = that.$refs.tabs
        const el = xTabs.$el.querySelector('.main-header-tabs .ant-tabs-nav-scroll>.ant-tabs-nav>div')
        that.sortable = Sortable.create(el, {
          handle: '.ant-tabs-tab',
          draggable: '.ant-tabs-tab:not(:first-of-type)',
          filter: '.ant-tabs-tab:first-child',
          animation: 150,
          ignore: 'img',
          onEnd: ({ newIndex, oldIndex }) => {
            const listData = this.$store.state.tabs.tabs
            listData.splice(newIndex, 0, listData.splice(oldIndex, 1)[0])
            const newArray = listData.slice(0)
            that.$store.commit('setTabs', newArray)
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.main-header-tabs {
  overflow: hidden;
  position: relative;
  &::v-deep {
    .ant-tabs-nav-container-scrolling {
      padding-right: 64px;
      padding-left: 0;
    }
    .ant-tabs-nav {
      .ant-tabs-tab.ant-tabs-tab-active:first-of-type {
        background-color: transparent;
      }
      .ant-tabs-tab:not(:first-of-type):hover,
      .ant-tabs-tab:not(.ant-tabs-tab-active):not(:first-of-type) {
        position: relative;
        &::before {
          position: absolute;
          top: 10px;
          left: 0;
          width: 1px;
          height: 12px;
          background-color: #fff;
          opacity: .3;
          content: '';
        }
      }
      .ant-tabs-tab:hover,
      .ant-tabs-tab-active {
        border-radius: 2px;
        color: #fff;
        background: rgba(17, 93, 87, .4);
        &::before {
          display: none;
        }
      }
      .ant-tabs-tab {
        margin: 4px 2px 4px 0 !important;
        border-radius: 2px;
        padding: 0;
        font-size: 12px;
        cursor: pointer;
      }
      .ant-tabs-tab:active {
        cursor: -webkit-grabbing;
      }
      .ant-tabs-tab:first-child:active {
        cursor: pointer;
      }
      .ant-tabs-ink-bar {
        display: none !important;
      }
    }
    .ant-tabs-tab-prev {
      right: 32px;
      left: auto;
    }
    .ant-tabs-bar {
      border-bottom: none;
      color: #fff;
      .ant-tabs-nav-container {
        height: 40px;
      }
    }
    .main-admin-tabs-item {
      display: flex;
      align-items: center;
      height: 20px;
      line-height: 20px;
    }
    .tabs-close-x {
      position: relative;
      top: 1px;
      margin-left: 4px;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      color: rgba(255, 255, 255, .6);
      transition: all .3s;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      .tabs-close {
        margin: 0 !important;
        font-size: 12px;
        transform: scale(0.7);
      }
      &:hover {
        color: rgba(255, 255, 255, 1);
        background-color: #03776e;
      }
    }
    .ant-tabs-tab-prev-icon,
    .ant-tabs-tab-next-icon {
      border-radius: 50%;
      width: 16px;
      height: 16px;
      line-height: 15px;
      background: #03b9aa;
    }
    .ant-tabs-tab-prev-icon:hover {
      background: #115d57;
    }
    .ant-tabs-tab-next-icon:hover {
      background: #115d57;
    }
    .ant-tabs-tab-prev-icon,
    .ant-tabs-tab-next {
      font-weight: bolder;
      color: rgba(255, 255, 255, .6);
      &:hover {
        color: rgba(255, 255, 255, 1);
      }
    }
    .tabs-item {
      a {
        display: block;
        padding: 6px 8px;
      }
    }
  }
}
</style>
